import { __decorate } from "tslib";
import { PsHttpService } from '@patsnap/tahiti-core/common/ps-http';
import { WORKSPACE_SERVICE_URI } from '@cores/constants/envConfig';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
let LazyLinkApiImpl = class LazyLinkApiImpl extends PsHttpService {
    get options() {
        return {
            // 只在非登录情况下调用
            baseURL: WORKSPACE_SERVICE_URI,
            headers: {
                'X-API-Version': '2.0',
            },
        };
    }
    getPatentSignatureApi(patentIds, folderId) {
        return this.post({
            url: '/workspace/web/patent-view/sign',
            data: {
                patent_ids: patentIds,
                folder_id: folderId,
            },
        }).then(res => res.data);
    }
};
LazyLinkApiImpl = __decorate([
    injectable()
], LazyLinkApiImpl);
export { LazyLinkApiImpl };
